import { render, staticRenderFns } from "./cardCreat.vue?vue&type=template&id=4f7b60ba&scoped=true"
import script from "./cardCreat.vue?vue&type=script&lang=js"
export * from "./cardCreat.vue?vue&type=script&lang=js"
import style0 from "./cardCreat.vue?vue&type=style&index=0&id=4f7b60ba&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7b60ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cyimu/Desktop/shiliang/vgo/VGO_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f7b60ba')) {
      api.createRecord('4f7b60ba', component.options)
    } else {
      api.reload('4f7b60ba', component.options)
    }
    module.hot.accept("./cardCreat.vue?vue&type=template&id=4f7b60ba&scoped=true", function () {
      api.rerender('4f7b60ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/components/cardCreat.vue"
export default component.exports